// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'core-promise/client/core-promise.js'
import 'es5-shim/es5-shim.min.js'
import 'es5-shim/es5-sham.min.js'
import 'html5shiv'
import 'es6-promise/auto'
import 'babel-polyfill'
import 'es6-shim/es6-shim.min.js'
import 'es6-shim/es6-sham.min.js'

// "json3": "^3.3.2",
// import 'json3'
// "es6-shim": "^0.35.3",
// "es7-shim": "^6.0.0",
// import 'es6-shim/es6-shim.min.js'
// import 'es6-shim/es6-sham.min.js'
// Only shim available yet for es7
// import 'es7-shim'

import Vue from 'vue'
import App from './App'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import router from './router'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import store from './vuex/store'

import VueTables from 'vue-tables-2'

// import VueStrap from 'vue-strap'
// Vue.use(VueStrap)
// import 'chart.js'
// import 'hchs-vue-charts'
// Vue.use(window.VueCharts)

Vue.config.productionTip = false
Vue.config.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'fr'

// set plugin
/* global locales */

// set locales
Object.keys(locales).forEach(function (lang) {
  Vue.locale(lang, locales[lang])
})

/* Cookie handling */
// import 'js-cookie/src/js.cookie.js'
// require('js-cookie'); // Used in Tracker.vue
window.Cookies = require('js-cookie')
window.md5 = require('md5')

// Bootstrap SASS Integration
// require('../node_modules/bootstrap-sass/assets/stylesheets/_bootstrap.scss')

// Global custom stylesheet
require('./assets/scss/app.scss')

// Font-Awesome Integration
require('../node_modules/font-awesome/scss/font-awesome.scss')

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

// Always check if authentication exists - redirect to index if not
router.beforeEach((to, from, next) => {
  if (to.path !== '/' && to.path !== '/login' && to.path !== '/recoverPassword') {
    if (!store.getters.isAuthenticated) {
      store.commit('LOGOUT')
      // Redirect to the first page
      next('/')
    } else {
      // OK, go further
      next()
    }
  } else {
    if (store.getters.isAuthenticated) {
      next('/mainview')
    } else {
      next()
    }
  }
})

Vue.use(
  VueTables.ClientTable,
  {
    sortIcon: {
      base: 'fa',
      up: 'fa-angle-up',
      down: 'fa-angle-up',
      is: 'fa-angle-up'
    },
    theme: 'bootstrap4'
  })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js